import React, { useEffect } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
import authService from "src/service/auth";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Change Password ",
  },
];

const validationSchema = yup.object({
  old_password: yup
    .string("Enter Old password")
    .min(8, "Old password should be of 8 digit length")
    .max(8, "Old password should be of 8 digit length")
    .required("Old password is Required"),
  new_password: yup
    .string("Enter new password")
    .min(8, "new password should be of 8 digit length")
    .max(8, "new password should be of 8 digit length")
    .required("new password is Required"),
  confirm_password: yup
    .string("Enter Confirm password")
    .min(8, "Confirm password should be of 8 digit length")
    .max(8, "Confirm password should be of 8 digit length")
    .required("Confirm password is Required"),
});

const ChangePassword = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  // get drivers list

  const initialValues = {
    contact: sessionData.data.contact_no,
    users_user_type: sessionData.data.user_type,
    old_password: "",
    new_password: "",
    confirm_password: "",
    d_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values, { resetForm }) => {
        // alert(JSON.stringify(values, null, 2));
        try {
          const res = await authService.changePasswordApi(values);

          swal("success", res.message, "success");
          // setTimeout(() => {
          //   navigate("/assignVehicleDriver");
          // }, 1000);
          resetForm();
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  return (
    <div>
      <Breadcrumb title="Change Password" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Change Password
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate(-1);
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            {/*   ==== assign driver name  -===  */}
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="old_password">
                Old password <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>

              <CustomTextField
                id="old_password"
                name="old_password"
                type="password"
                value={values.old_password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.old_password && Boolean(errors.old_password)}
                helperText={touched.old_password && errors.old_password}
                variant="outlined"
                placeholder="Enter Old Password"
                fullWidth
              />
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="new_password">
                New Password <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="new_password"
                name="new_password"
                type="password"
                value={values.new_password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.new_password && Boolean(errors.new_password)}
                helperText={touched.new_password && errors.new_password}
                variant="outlined"
                placeholder="Enter new password"
                fullWidth
              />
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="confirm_password">
                Confirm Password <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="confirm_password"
                name="confirm_password"
                type="password"
                value={values.confirm_password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  touched.confirm_password && Boolean(errors.confirm_password)
                }
                helperText={touched.confirm_password && errors.confirm_password}
                variant="outlined"
                placeholder="Enter Confirm password"
                fullWidth
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="success" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default ChangePassword;
